var _excluded = ["spacing", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useCheckbox } from '../checkbox';
import { tqc, forwardRef, omitThemingProps, useMultiStyleConfig } from '../../system';
import { cx, dataAttr, __DEV__ } from '../../utils';
import * as React from 'react';
export var Switch = forwardRef((props, ref) => {
  var styles = useMultiStyleConfig('Switch', props);
  var _omitThemingProps = omitThemingProps(props),
    {
      spacing = '0.5rem',
      children
    } = _omitThemingProps,
    ownProps = _objectWithoutProperties(_omitThemingProps, _excluded);
  var {
    state,
    getInputProps,
    getCheckboxProps,
    getRootProps,
    getLabelProps
  } = useCheckbox(ownProps);
  var isVertical = props.orientation === 'vertical';
  var rotateProp = isVertical ? 'rotate(90deg)' : 'unset';
  var containerStyles = React.useMemo(() => _objectSpread({
    display: 'inline-block',
    verticalAlign: 'middle',
    lineHeight: 'normal',
    transform: [rotateProp]
  }, styles.container), [styles.container, rotateProp]);
  var trackStyles = React.useMemo(() => _objectSpread({
    display: 'inline-flex',
    flexShrink: 0,
    justifyContent: 'flex-start',
    boxSizing: 'content-box',
    cursor: 'pointer'
  }, styles.track), [styles.track]);
  var labelStyles = React.useMemo(() => _objectSpread({
    userSelect: 'none',
    marginStart: spacing
  }, styles.label), [spacing, styles.label]);
  return /*#__PURE__*/React.createElement(tqc.label, _extends({}, getRootProps(), {
    className: cx('tqc-switch', props.className),
    __css: containerStyles
  }), /*#__PURE__*/React.createElement("input", _extends({
    className: "tqc-switch__input"
  }, getInputProps({}, ref))), /*#__PURE__*/React.createElement(tqc.span, _extends({}, getCheckboxProps(), {
    className: "tqc-switch__track",
    __css: trackStyles
  }), /*#__PURE__*/React.createElement(tqc.span, {
    __css: styles.thumb,
    className: "tqc-switch__thumb",
    "data-checked": dataAttr(state.isChecked),
    "data-hover": dataAttr(state.isHovered)
  })), children && /*#__PURE__*/React.createElement(tqc.span, _extends({
    className: "tqc-switch__label"
  }, getLabelProps(), {
    __css: labelStyles
  }), children));
});
if (__DEV__) {
  Switch.displayName = 'Switch';
}